import type { ComposeTeamBenchCard } from '__generated__/globalTypes';

import { idFromObject } from './idFromObject';

type AllowedConvertedTypes = ComposeTeamBenchCard['__typename'];

export const convertObjectId = (
  id: string,
  type: AllowedConvertedTypes
): string => {
  if (type === 'ComposeTeamBenchCard') {
    return `${type}:${idFromObject(id)}`;
  }
  return id;
};
